import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import {  toast } from "react-toastify";
import { onChange_CohortName, onChange_CohortType, onChange_CohortAreaName, onChange_CohortSelectUser, onChange_CohortSelectVM } from "./action";
import CohortCreationComponent from "./component";

const steps = [
  "Cohort Name",
  "Cohort Type",
  "Area Name",
  "Select User",
  "Select Vending Machine"
];

const CohortCreationContainer = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepCompleted, setStepCompleted] = useState(Array(steps.length).fill(false));
  const [errors, setErrors] = useState({});
  const [seedData, setSeedData] = useState([]);
  const [cohortName, setCohortName] = useState("");
  const [cohortType, setCohortType] = useState("");
  const [cohortAreaName, setCohortAreaName] = useState("");
  const [cohortSelectUser, setCohortSelectUser] = useState([]);
  const [cohortSelectVM, setCohortSelectVM] = useState([]);
  const [isCohortCreated, setIsCohortCreated] = useState(false);
  const [cohortId, setCohortId] = useState(null);

  const navigate = useNavigate();

  const handleNext = async () => {
    let isValid = true;
    let newErrors = {};
    const invalidCharsRegex = /[^a-zA-Z0-9\s]/; 
  
    if (activeStep === 0) {
      if (!cohortName) {
        newErrors.cohortName = "Cohort name is required";
        isValid = false;
      } else if (cohortName.length < 3) {
        newErrors.cohortName = "Cohort name must be at least 3 characters";
        isValid = false;
      } else if (invalidCharsRegex.test(cohortName)) {
        newErrors.cohortName = "Cohort  name must contain only letters, numbers, and spaces.f";
        isValid = false;
      }
    }
  
   
    if (activeStep === 1) {
      if (!cohortType) {
        newErrors.cohortType = "Cohort type is required";  
        isValid = false;
      }
    }
    if (activeStep === 2) {
      if (!cohortAreaName) {
        newErrors.cohortAreaName = "Cohort area name is required";
        isValid = false;
      } else if (cohortAreaName.length < 3) {
        newErrors.cohortAreaName = "Cohort area name must be at least 3 characters";
        isValid = false;
      }else if (invalidCharsRegex.test(cohortAreaName)) {
        newErrors.cohortAreaName = "Cohort area name must be at least 3 characters";
        isValid = false;
      }
    }
  
    if (activeStep === 3) {
      if (!cohortSelectUser.length) {
        newErrors.cohortSelectUser = "At least one user must be selected";
        isValid = false;
      }
    }
  
    if (activeStep === 4) {
      if (!cohortSelectVM.length) {
        newErrors.cohortSelectVM = "At least one vending machine must be selected";
        isValid = false;
      }
    }
    setErrors(newErrors);
    if (isValid) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };
  
  const handleClose = () => {
    if (activeStep === 0) {
      navigate(-1); 
    } else {
      setActiveStep((prevStep) => prevStep - 1); 
    }
  };
  
  const handleCohortNameChange = (event) => {
    const name = event.target.value; 
    const invalidCharsRegex = /[^a-zA-Z0-9\s]/;   
    if (name.trim().length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortName: "Cohort name is required and cannot be just spaces.",
      }));
    } else if (name.length <= 30 && !invalidCharsRegex.test(name)) {
      setCohortName(name);
      setErrors((prevErrors) => ({ ...prevErrors, cohortName: null })); 
    } else if (invalidCharsRegex.test(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortName: "Cohort name must contain only letters, numbers, and spaces.",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortName: "Cohort name must be less than or equal to 30 characters.",
      }));
    }
    setCohortName(name);
  };
  
  const handleCohortAreaNameChange = (event) => {
    const area = event.target.value; 
    const invalidCharsRegex = /[^a-zA-Z0-9\s]/; 
    if (area.trim().length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortAreaName: "Cohort area name is required and cannot be just spaces.",
      }));
    } else if (area.length == 30 && !invalidCharsRegex.test(area)) {
      setCohortAreaName(area);
      setErrors((prevErrors) => ({ ...prevErrors, cohortAreaName: null })); 
    } else if (invalidCharsRegex.test(area)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortAreaName: "Cohort area name must contain only letters, numbers, and spaces.",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cohortAreaName: "Cohort area name must be less than or equal to 30 characters.",
      }));
    }
  
  
    setCohortAreaName(area);
  };
  
const handleCohortTypeChange = (type) => {
  console.log("Cohort type received in handleCohortTypeChange:", type); 
  setCohortType(type);
  console.log("Cohort type state after update:", cohortType); 
};


// const handleCohortAreaNameChange = (event) => {
//   const area = event.target.value;
//   if (area.length <= 30) { 
//     setCohortAreaName(area);
//   }
// };
  const handleCohortSelectUserChange = (selectedUsers) => {
    setCohortSelectUser(selectedUsers);
  };
  const handleCheckboxChange = (event, id) => {
    const newSelectedUsers = event.target.checked
      ? [...cohortSelectUser, id]  
      : cohortSelectUser.filter((userId) => userId !== id);  
  
    setCohortSelectUser(newSelectedUsers); 
  };
  
  const handleCohortSelectVMChange = (selectedVMs) => {
    setCohortSelectVM(selectedVMs);
    
    if (selectedVMs.length) {
      setErrors((prevErrors) => ({ ...prevErrors, cohortSelectVM: null }));
    }
  };
 

// const handleCreateNewCohort = async () => {
  
//   const payload = {
//     name: cohortName,
//     cohortTypeId: parseInt(cohortType, 10),  
//     areaName: cohortAreaName,
//     lat: "",
//     lng: "",
//     description: "",
//     userIdCollection: cohortSelectUser,
//     vmCollection: cohortSelectVM,
//   };
//   try {
//     const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts`;
//     props.getDataFromAPI(url, "POST", payload, (response) => {
//       if (response && response.cohortId) {
       
//         const updatedStepCompletion = [...stepCompleted];
//         updatedStepCompletion[activeStep] = true; 
//         setStepCompleted(updatedStepCompletion);
        
//         setIsCohortCreated(true);
//         setCohortId(response.cohortId);
//         toastr.success("Success", "Cohort created successfully");
//       } else {
//         toastr.error("Failed", "Unable to retrieve cohort ID");
//       }
//     });
//   } catch (err) {
    
//     console.log("err cohort create api ", err.message);
//     toastr.error(`${err.message}`, {
//       position: toast.POSITION.TOP_RIGHT,
//       autoClose: 1000,
//     });
  
// }
// };

const handleCreateNewCohort = async () => {
  if (!cohortSelectVM.length) { 
    setErrors((prevErrors) => ({
      ...prevErrors,
      cohortSelectVM: "At least one vending machine must be selected",
    }));
   
    return;  
  }
  const payload = {
    name: cohortName,
    cohortTypeId: parseInt(cohortType, 10),
    areaName: cohortAreaName,
    lat: "",
    lng: "",
    description: "",
    userIdCollection: cohortSelectUser,
    vmCollection: cohortSelectVM,
  };

  try {
    const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts`;
    props.getDataFromAPI(url, "POST", payload, (response) => {
      if (response && response.cohortId) {
        const updatedStepCompletion = [...stepCompleted];
        updatedStepCompletion[activeStep] = true;
        setStepCompleted(updatedStepCompletion);

        setIsCohortCreated(true);
        setCohortId(response.cohortId);
        toastr.success("Success", "Cohort created successfully");
      } else {
        toastr.error("Failed", "Unable to retrieve cohort ID");
      }
    });
  } catch (err) {
    console.log("err cohort create api ", err.message);
    toastr.error(`${err.message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    });
  }
};

  useEffect(() => {
    handleGetSeedData();
  }, []);

  const handleGetSeedData = () => {
    const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/seed`;
    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        console.log("seed response:", response);
        setSeedData(response);
      },
      (err) => {
        console.log("error---", err);
        toastr.error("Failed", "Unable to fetch seed data");
      }
    );
  };

  return (
    <>
      <CohortCreationComponent
        activeStep={activeStep}
        handleNext={handleNext}
        handleClose={handleClose}
        errors={errors}
        stepCompleted={stepCompleted}
        seedData={seedData}
        cohortName={cohortName}
        handleCohortNameChange={handleCohortNameChange}
        cohortType={cohortType}
        handleCohortTypeChange={handleCohortTypeChange}
        cohortAreaName={cohortAreaName}
        handleCohortAreaNameChange={handleCohortAreaNameChange}
        cohortSelectUser={cohortSelectUser}
        handleCohortSelectUserChange={handleCohortSelectUserChange}
        cohortSelectVM={cohortSelectVM}
        handleCohortSelectVMChange={handleCohortSelectVMChange}
        handleCreateNewCohort={handleCreateNewCohort}
        handleCheckboxChange={handleCheckboxChange}
        isCohortCreated={isCohortCreated}
        cohortId={cohortId}
      />
    </>
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_CohortName,
  onChange_CohortType,
  onChange_CohortAreaName,
  onChange_CohortSelectUser,
  onChange_CohortSelectVM,
})(CohortCreationContainer);
